import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import AddLDAPServer from "../../Components/AddLDAPServerModal/AddLDAPServer";
import { useTranslation } from "react-i18next";
// import EditLDAPServer from '../../Components/EditLDAPServerModal/EditLDAPServer';
import SyncModal from "../../Components/SyncModal/SyncModal";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";
const LDAPServer = () => {
  const [data, setLDAPServer] = useState([]);
  const [links, setLinks] = useState([]);
  const [deleted, setDeleted] = useState("");
  const { t } = useTranslation();
  const [searchVal, setSearchVal] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedLDAPServerId, setSelectedLDAPServerId] = useState(null);

  const handleTestConnection = async (id) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/ldap/test-connection/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (response.ok && data.status === "success") {
        showToast(t(data.message || t("LDAPConnectionSuccess")), "success");
      } else {
        showToast(t(data.message || t("LDAPConnectionFailed")), "error");
      }
    } catch (error) {
      showToast(t("Anerroroccurredduringconnectiontest"), "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/ldap_servers/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        showToast(t("ldapdeletesuccess"), "success");
        fetchLDAPServer("");
        setShowModal(false);
      } else {
        setShowModal(false);
        showToast(t("ldapdeletefailed"), "error");
      }
    } catch (error) {
      showToast(t("ldapdeleteerror"), "error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (searchVal !== "") {
      const filteredData = data.filter(
        (item) =>
          item.title.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.host.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.server_type.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.security_type.toLowerCase().includes(searchVal.toLowerCase())
      );
      setLDAPServer(filteredData); // Update filtered data
    } else {
      fetchLDAPServer(""); // Update filtered data
    }
  }, [searchVal]);

  const fetchLDAPServer = async (url) => {
    setLoading(true);
    let page = 1;
    if (url !== "") {
      const temp = url.split("?page=");
      page = temp[1];
      
    }

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/ldap_servers?page=${page}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setLDAPServer(result?.data?.data); // Update state with fetched data
      console.log("result links:", result);
      setLinks(result?.data?.links); // Update pagination links
    } catch (error) {
      console.error("Error fetching LDAP server data:", error);
      showToast(t("ldapfetcherror"), "error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //     fetchLDAPServer('');
  // }, []);

  // useEffect(() => {
  //     fetchLDAPServer('');
  // }, []);
  // Define table columns
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "title",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-card-text"></i>
            {t("Title")}
          </div>
        ),
        colName: t("Title"),
      },
      {
        accessorKey: "host",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-globe"></i>
            {t("Host")}
          </div>
        ),
        colName: t("Host"),
      },
      {
        accessorKey: "port",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-link"></i>
            {t("Port")}
          </div>
        ),
        colName: t("Port"),
      },
      {
        accessorKey: "server_type",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-server"></i>
            {t("ServerType")}
          </div>
        ),
        colName: t("ServerType"),
      },

      {
        accessorKey: "security_type",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-key-fill"></i>
            {t("SecurityType")}
          </div>
        ),
        colName: t("SecurityType"),
      },
      {
        accessorKey: "Connection",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-ethernet"></i>
            {t("Connection")}
          </div>
        ),
        cell: ({ row }) => {
          const id = row.original.id;

          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleTestConnection(id);
                }}
                style={{
                  cursor: "pointer",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  border: "1px solid #007bff",
                  // backgroundColor: "#007bff",
                  color: "#fff",
                  fontSize: "0.9rem",
                  textAlign: "center",
                }}
              >
                {t("TestConnection")}
              </button>
            </div>
          );
        },
        colName: t("Connection"),
      },

      {
        accessorKey: "id",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src="/images/fi_alert-octagon.png" alt="Source" />
            {t("Action")}
          </div>
        ),
        cell: ({ getValue }) => {
          const id = getValue();
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <SyncModal id={id} />
              </div>

              {/* <EditLDAPServer id={id}  parentfetchLDAPServer={fetchLDAPServer}/>  */}

              <div
                className="iconDel"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedLDAPServerId(id);
                  setShowModal(true);
                  setLoading(true);
                  setLoading(false);
                }}
              >
                <img src="/images/fi_trash-2.png" alt="Delete" />
                {t("Delete")}
              </div>
            </div>
          );
        },
        colName: t("Action"),
      },
    ],
    []
  );

  // Create a table instance
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });
  const handleSurveyRowClick = (id) => {
    navigate(`/ldapservermodel/${id}/LDAPServerDetail`);
  };
  return (
    <div className="p-4 mb-4">
      <div className="pageTitle mb-4">{t("AllLDAPServer")}</div>
      <div className="primaryBlueBox p-5 mb-4">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchLDAPServer")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbytitle")}
                aria-label="Search LDAP Server"
                value={searchVal} // Bind input value to searchVal state
                onChange={(e) => setSearchVal(e.target.value)} // Update searchVal on input change
              />{" "}
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-1">
            <div className="vrLine"></div>
          </div>
          <div className="col-md-7">
            {/* <AddLDAPServer parentfetchLDAPServer={fetchLDAPServer} /> */}
            <NavLink className="btnWhiteGradient mt-4" to="/add-ldap-server">
              <i class="bi bi-envelope me-2 mt-3 h6"></i> {t("AddLDAPServer")}
            </NavLink>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center my-5">
          <div
            className="spinner-border"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          ></div>
        </div>
      ) : (
        <div className="bg-light px-3 py-3 lessonsTableWrapper resTable overflow-auto">
          {window.innerWidth < 768 ? (
            table.getRowModel().rows.map((row) => (
              <div
                key={row.id}
                className="stacked-row"
                onClick={
                  row.id.includes("id") === false
                    ? () => handleSurveyRowClick(row.original.id)
                    : null
                }
              >
                {row.getVisibleCells().map((cell) => (
                  <div key={cell.id} className="stacked-cell">
                    <strong className="me-1">
                      {cell.column.columnDef.colName}:
                    </strong>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <table className="table table-bordered table-hover">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className="rowAnchor"
                        onClick={
                          cell.id.includes("id") === false
                            ? () => handleSurveyRowClick(row.original.id)
                            : null
                        }
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null ? () => fetchLDAPServer(link.url) : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ConfirmDelete")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("AreyousureyouwanttodeletethisLDAPServer?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={() => handleDelete(selectedLDAPServerId)}
            disabled={loading}
          >
            {loading ? t("Deleting...") : t("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LDAPServer;
